// Flux Announcement Bar Hider
if (window.location.search.includes('from_flux=1')) {
  document.addEventListener('DOMContentLoaded', function () {
    var selectors = [
      '#shopify-section-announcement-bar',
      '.announcement-bar',
      '.announcement-bar-section',
      '[data-section-type="announcement-bar"]'
    ];

    selectors.forEach(function (sel) {
      var el = document.querySelector(sel);
      if (el) {
        el.style.setProperty('display', 'none', 'important');
        el.style.setProperty('height', '0px', 'important');
        el.style.setProperty('min-height', '0px', 'important');
        el.style.setProperty('max-height', '0px', 'important');
        el.style.setProperty('overflow', 'hidden', 'important');
      }
    });
  });
}

// BFCache reload logic
window.addEventListener("pageshow", function (event) {
  if (event.persisted) {
    console.log("♻️ Restored from bfcache, refreshing content...");
    window.location.reload(); // ensures always fresh on mobile back/forward
  }
});

// WhatsApp Delay Logic
document.addEventListener("DOMContentLoaded", function () {
  let waLoaded = false;
  
  function revealWhatsApp() {
    if (waLoaded) return;
    waLoaded = true;
    document.body.classList.add('show-whatsapp');
  }
  
  // إظهار الواتساب عند أول تفاعل (تمرير، لمس، أو تحريك الماوس)
  ['scroll', 'touchstart', 'mousemove', 'click'].forEach(function(event) {
    window.addEventListener(event, revealWhatsApp, { once: true, passive: true });
  });
  
  // كإجراء احتياطي: إظهاره بعد 5 ثوانٍ حتى لو لم يتحرك العميل
  setTimeout(revealWhatsApp, 5000);
});

// App Cart Sync Logic
function sendCartToApp() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(data => {
      if (window.CartChannel) {
        CartChannel.postMessage(data.item_count.toString());
      }
    });
}

// Tell the app the cart number as soon as the page loads
sendCartToApp();

// Tell the app to check the cart again anytime a button is clicked
document.addEventListener('click', function() {
   setTimeout(sendCartToApp, 1500); 
});
